export default '/build/2ef22e19.svg'